import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { App } from "./App";
export function AppRouter() {
  return <BrowserRouter data-id="element-5">
          <Routes data-id="element-6">
            <Route path="/" element={<App data-id="element-8" />} data-id="element-7" />
          </Routes>
      </BrowserRouter>;
}